import React, { ReactElement } from 'react';

import { TextField } from '@mui/material';
import { useGlobalization } from '../../../../../../i18n/useGlobalization';

const SpatialFilterInput = (): ReactElement => {
	const { t } = useGlobalization();
	return (
		<TextField
			label="Value"
			defaultValue={t('Area Drawn')}
			InputProps={{
				readOnly: true,
			}}
			variant="standard"
		/>
	);
};

export default SpatialFilterInput;
